<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <submenu />

        <div v-if="isDisabled" class="message message--warning">
          {{ L.localize('Membership_PaymentOptions_CannotBeEdited_Content') }}
        </div>

        <TextBox
          label="Label_Name"
          v-model="model.name"
          :validate="$v.model"
          v-on:input="$v.model.name.$touch"
          modelPath="name"
          acc="name"
          :disabled="isDisabled"
        />

        <TextBox
          label="Label_Amount"
          v-model="model.amount"
          :validate="$v.model"
          v-on:input="$v.model.amount.$touch"
          modelPath="amount"
          type="number"
          :min="0"
          :max="10000"
          step="0.01"
          acc="amount"
          :disabled="isDisabled"
        />

        <SelectList label="Membership_PaymentOptions_RepeatsType" :disabled="isDisabled" v-model="model.repeatsType" :options="repeatsTypeOptions" acc="repeatstype" />

        <TextBox
          v-if="model.repeatsType == 3"
          label="Label_DurationInMonths"
          v-model="model.durationInMonths"
          :validate="$v.model"
          v-on:input="$v.model.durationInMonths.$touch"
          modelPath="durationInMonths"
          type="number"
          :min="1"
          :max="10000"
          step="1"
          acc="durationInMonths"
          :disabled="isDisabled"
        />

        <Btn :isLoading="loading" v-on:click="save" label="Label_SaveButton" />
        <Btn v-on:click="$router.push({name: 'payment-options'})" label="Label_CancelButton" :withBorder="true" />
      </div>
    </article>
  </article>
</template>

<script>
import { TextBox, Btn, SelectList } from 'components/layout/forms'
import L from 'services/Localization'
import Format from 'services/Format'
import { mapGetters } from 'vuex'
import Submenu from 'components/views/membership/Submenu'
import notifications from 'mixins/notifications'
import { required } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'

export default {
  name: 'payment-option',
  components: { Submenu, TextBox, Btn, Validation, SelectList },
  mixins: [notifications],
  data() {
    return {
      L: L,
      loading: false,
      title: L.localize('Membership_Breadcrumb_Index'),
      model: {
        id: '',
        name: '',
        amount: 0,
        repeatsType: 0,
        durationInMonths: 0
      }
    }
  },
  beforeCreate() {
    this.$store.dispatch('getRepeatsTypes')
    this.$store.dispatch('getPaymentOption', this.$route.params.id).then(() => {
      this.mapFromState()
    })
  },
  beforeDestroy() {
    this.$store.dispatch('getPaymentOption', null)
  },
  validations: {
    model: {
      name: { required },
      amount: { required },
      durationInMonths: {
        isDurationInMonthsRequired (value) {
          return this.isDurationInMonthsRequired(value)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      paymentOption: 'activePaymentOption',
      repeatsTypes: 'allRepeatsTypes'
    }),
    isDisabled() {
      if (this.paymentOption.stripeId) {
        return true
      }
      return false
    },
    repeatsTypeOptions() {
      return this.repeatsTypes.map(type => {
        return {
          value: type,
          label: Format.repeatsType(type)
        }
      })
    }
  },
  methods: {
    isDurationInMonthsRequired(value) {
      return !(this.model.repeatsType === '3' && value === '')
    },
    mapFromState() {
      _.assign(this.model, this.paymentOption)
      if (this.paymentOption) {
        this.title = this.paymentOption.name
      }
    },
    save() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return;
      }
      this.loading = true
      let paymentOption = this.model
      this.$store.dispatch('createOrUpdatePaymentOption', paymentOption).then(
        // resolve
        () => {
          this.loading = false
          if (paymentOption.id === '') {
            this.$router.push({name: 'payment-option', params: { id: this.paymentOption.id }})
            this.showNotification({
              title: L.localize('Label_SuccessCreation'),
              message: L.localize('Label_Success')
            })
          } else {
            this.mapFromState()
            this.showNotification({
              title: L.localize('Label_SuccessEdit'),
              message: L.localize('Label_Success')
            })
          }
        },
        // reject
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaymentOption.vue?66fcd023